import { render, staticRenderFns } from "./two.vue?vue&type=template&id=645bb6b7&scoped=true&"
import script from "./two.vue?vue&type=script&lang=js&"
export * from "./two.vue?vue&type=script&lang=js&"
import style0 from "./two.vue?vue&type=style&index=0&id=645bb6b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645bb6b7",
  null
  
)

export default component.exports